<template>
  <v-layout>
    <app-loader
      title="Загрузка данных Затаможки"
      :loading="!pageLoaded"
    />
    <v-layout
      v-show="pageLoaded"
      row
      wrap
    >
      <!-- INFO -->
      <v-flex
        xs12
        md4
      >
        <v-card
          class="mt-0 mb-2 mr-1 ml-0 pa-2"
          :style="{
            height: '255px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
          }"
        >
          <v-layout align-center>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                small
                icon
                class="ma-0"
                @click="$router.go(-1)"
              >
                <v-icon color="grey darken-1">
                  arrow_back
                </v-icon>
              </v-btn>
              <span>Назад</span>
            </v-tooltip>
            <h1 class="subheading font-weight-bold px-1">
              Затаможка
            </h1>
          </v-layout>
          <v-layout
            row
            wrap
            align-center
          >
            <v-flex>
              <span class="subheading blue--text text--darken-4">{{
                `Маршрут: №${routeNumber}`
              }}</span>
            </v-flex>
            <v-flex>
              <span class="subheading blue--text text--darken-4">Префикс:</span>
              <span
                v-if="!showRoutePrefixEditor"
                class="subheading font-weight-bold pr-1 clickable-row"
                @click="showRoutePrefixEditor = true"
              >{{
                route && route.RoutePrefix ? route.RoutePrefix : "___"
              }}</span>
              <span
                v-else
                style="width:65px"
              >
                <v-text-field
                  v-model="route.RoutePrefix"
                  hide-details
                  outline
                  append-icon="save"
                  height="30"
                  class="route-prefix"
                  maxlength="6"
                  autofocus
                  @click:append="saveRoutePrefix"
                  @blur="showRoutePrefixEditor = false"
                />
              </span>
            </v-flex>
            <v-flex>
              <MenuStateChange
                :id="id"
                resource="customsEntryRegistration"
              />
            </v-flex>
            <v-flex>
              <states-history class="ml-2" />
            </v-flex>
          </v-layout>
          <v-layout class="mb-2">
            <v-flex>
              <span class="blue--text text--darken-4">Номер машины:&nbsp;</span>
              <span>{{ vehicle }}</span>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <DriverSelect
              resource="customsEntryRegistration"
              :item="route"
              store-resource="customsEntryRegistration"
              @change="changeDriver"
            />
          </v-flex>
          <v-flex xs11>
            <CustomsManagerSelect
              class="pl-1"
              :value="customsManager"
              :disabled-edit-btn="!customsManager"
              @input="changeCustomsManager"
            />
          </v-flex>
          <v-flex xs11>
            <RouteReference
              :value="forwarder"
              label="Экспедитор"
              resource="forwarders"
              component-name="Forwarder"
              :disabled-edit-btn="!forwarder"
              store-resource="customsEntryRegistration"
              class="pl-1"
              @input="updateForwarder"
            />
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex
        xs12
        md4
      >
        <v-layout column>
          <v-card
            class="mt-0 mb-2 mx-1 pa-2"
            :style="{
              height: '255px',
              'overflow-y': 'auto',
              'overflow-x': 'auto'
            }"
          >
            <v-layout>
              <v-tabs
                this-active-tab="value"
                @change="
                  value => {
                    activeTab = value;
                  }
                "
              >
                <v-tab style="text-transform:none">
                  <h2 class="subheading font-weight-bold">
                    Даты
                  </h2>
                </v-tab>
                <v-tab style="text-transform:none">
                  <h2 class="subheading font-weight-bold">
                    Экспедиция
                  </h2>
                </v-tab>
                <v-tab style="text-transform:none">
                  <h2 class="subheading font-weight-bold">
                    Граница
                  </h2>
                </v-tab>
                <v-tab style="text-transform:none">
                  <h2 class="subheading font-weight-bold">
                    Отчеты
                  </h2>
                </v-tab>
                <v-tabs-items>
                  <!-- Dates  -->
                  <v-tab-item>
                    <v-data-table
                      v-if="route"
                      :items="itemsDatesTable"
                      :headers="headersDatesTable"
                      hide-actions
                      :loading="loadingDates"
                    >
                      <template
                        slot="items"
                        slot-scope="props"
                      >
                        <tr>
                          <td style="width:50%">
                            {{ props.item.title }}
                          </td>
                          <td v-if="props.item.plan.readonly">
                            {{ route[props.item.plan.field] | date }}
                          </td>
                          <td
                            v-else
                            class="date-picker"
                            style="width:25%"
                          >
                            <app-date-picker
                              v-model="route[props.item.plan.field]"
                              :without-initial-data="true"
                              :padding="0"
                              :outline="false"
                              :hide-data-type-icon="true"
                              @input="changeDates"
                            />
                          </td>
                          <td v-if="props.item.fact.readonly">
                            {{ route[props.item.plan.field] | date }}
                          </td>
                          <td
                            v-else
                            class="date-picker"
                            style="width:25%"
                          >
                            <app-date-picker
                              v-model="route[props.item.fact.field]"
                              :without-initial-data="true"
                              :padding="0"
                              :outline="false"
                              :hide-data-type-icon="true"
                              @input="changeDates"
                            />
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-tab-item>

                  <!-- Expedition  -->
                  <v-tab-item class="mt-3">
                    <v-layout
                      v-if="route"
                      wrap
                    >
                      <v-flex
                        xs12
                        md6
                      >
                        <DecimalEditor
                          v-model="routeEx"
                          label="EX"
                          :scale="2"
                          :placeholder="placeholder"
                          :height-field="40"
                          class="ma-2"
                          @input="updateExpedition('updateEx')"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                      >
                        <DecimalEditor
                          v-model="routeT1"
                          label="T1"
                          :scale="2"
                          :placeholder="placeholder"
                          :height-field="40"
                          class="ma-2"
                          @input="updateExpedition('updateT1')"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                      >
                        <DecimalEditor
                          v-model="routeTir"
                          label="TIR"
                          :scale="2"
                          :placeholder="placeholder"
                          :height-field="40"
                          class="ma-2"
                          @input="updateExpedition('updateTir')"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                      >
                        <DecimalEditor
                          v-model="additionalExpenses"
                          label="Доп. расходы"
                          :scale="2"
                          :placeholder="placeholder"
                          :height-field="40"
                          class="ma-2"
                          @input="updateExpedition('updateAdditionalExpenses')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-tab-item>

                  <!-- BorderPassCosts -->
                  <v-tab-item class="mt-3">
                    <template v-if="route">
                      <v-list-tile class="compact">
                        <v-layout
                          row
                          class="mb-1"
                        >
                          <v-flex
                            xs4
                            class="pt-1"
                          >
                            <span
                              class="blue--text text--darken-4"
                            >Черный:</span>
                          </v-flex>
                          <v-flex xs4>
                            <DecimalEditor
                              v-model="borderPassBlack"
                              class="ma-0 pa-0"
                              :placeholder="placeholder"
                              :height-field="40"
                              @blur="
                                changeBorderPassCost('black', 'borderPassBlack')
                              "
                            />
                          </v-flex>
                          <v-flex
                            xs4
                            class="pl-1"
                          >
                            <CurrencyReference
                              v-model="borderPassBlackCurrency"
                              title-for-nested-editor="Валюта"
                              @input="
                                changeBorderPassCost('black', 'borderPassBlack')
                              "
                            />
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile class="compact">
                        <v-layout
                          row
                          class="mb-1"
                        >
                          <v-flex
                            xs4
                            class="pt-1"
                          >
                            <span
                              class="blue--text text--darken-4"
                            >Зеленый:</span>
                          </v-flex>
                          <v-flex xs4>
                            <DecimalEditor
                              v-model="borderPassGreen"
                              class="ma-0 pa-0"
                              :placeholder="placeholder"
                              :height-field="40"
                              @blur="
                                changeBorderPassCost('green', 'borderPassGreen')
                              "
                            />
                          </v-flex>
                          <v-flex
                            xs4
                            class="pl-1"
                          >
                            <CurrencyReference
                              v-model="borderPassGreenCurrency"
                              title-for-nested-editor="Валюта"
                              @input="
                                changeBorderPassCost('green', 'borderPassGreen')
                              "
                            />
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile class="compact">
                        <v-layout
                          row
                          class="mb-1"
                        >
                          <v-flex
                            xs4
                            class="pt-1"
                          >
                            <span
                              class="blue--text text--darken-4"
                            >На оформление:</span>
                          </v-flex>
                          <v-flex xs4>
                            <DecimalEditor
                              v-model="borderPassRegistration"
                              class="ma-0 pa-0"
                              :placeholder="placeholder"
                              :height-field="40"
                              @blur="
                                changeBorderPassCost(
                                  'registration',
                                  'borderPassRegistration'
                                )
                              "
                            />
                          </v-flex>
                          <v-flex
                            xs4
                            class="pl-1"
                          >
                            <CurrencyReference
                              v-model="borderPassRegistrationCurrency"
                              title-for-nested-editor="Валюта"
                              @input="
                                changeBorderPassCost(
                                  'registration',
                                  'borderPassRegistration'
                                )
                              "
                            />
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile class="compact">
                        <v-layout
                          row
                          class="mb-1"
                        >
                          <v-flex
                            xs4
                            class="pt-1"
                          >
                            <span
                              class="blue--text text--darken-4"
                            >Печати:</span>
                          </v-flex>
                          <v-flex xs4>
                            <DecimalEditor
                              v-model="borderPassStamp"
                              class="ma-0 pa-0"
                              :placeholder="placeholder"
                              :height-field="40"
                              @blur="
                                changeBorderPassCost('stamp', 'borderPassStamp')
                              "
                            />
                          </v-flex>
                          <v-flex
                            xs4
                            class="pl-1"
                          >
                            <CurrencyReference
                              v-model="borderPassStampCurrency"
                              title-for-nested-editor="Валюта"
                              @input="
                                changeBorderPassCost('stamp', 'borderPassStamp')
                              "
                            />
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </template>
                  </v-tab-item>

                  <!-- Reports -->
                  <v-tab-item class="mt-3">
                    <v-list dense>
                      <div
                        v-for="(report, i) in reportList"
                        :key="i"
                      >
                        <v-list-tile color="grey darken-2">
                          <v-list-tile-title class="default-cursor">
                            {{ report.title }}
                          </v-list-tile-title>
                          <v-list-tile-action>
                            <DownloadXlsxBtn
                              :loading="loadingExcel"
                              @download="downloadOutputForm(report.resource)"
                            />
                          </v-list-tile-action>
                        </v-list-tile>
                      </div>
                    </v-list>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-layout>
          </v-card>
        </v-layout>
      </v-flex>

      <!-- Labels & Attachments -->
      <v-flex
        xs12
        md4
      >
        <v-layout column>
          <v-card
            class="mt-0 mb-2 mr-0 ml-1 pa-2"
            :style="{
              height: '255px',
              'overflow-y': 'auto',
              'overflow-x': 'auto'
            }"
          >
            <v-tabs>
              <v-tab style="text-transform:none">
                <h2 class="subheading font-weight-bold">
                  Метки
                </h2>
              </v-tab>
              <v-tab style="text-transform:none">
                <h2 class="subheading font-weight-bold">
                  Документы
                  <span
                    v-if="attachments.length > 0"
                    class="blue--text text--darken-4"
                  >({{ attachments.length }})</span>
                </h2>
              </v-tab>
              <v-tab-item>
                <!-- Labels -->
                <lables
                  :id="id"
                  :values="lables"
                />
              </v-tab-item>
              <!-- ATTACHMENTS -->
              <v-tab-item>
                <Attachments
                  :value="attachments"
                  :resource="`customs-entry-registrations/${id}`"
                  @input="changeAttachments"
                />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-card
          class="pa-2"
          :style="{
            height: 'auto',
            'overflow-y': 'auto',
            'overflow-x': 'auto'
          }"
        >
          <v-layout row>
            <span class="subheader mb-2">Данные по товарам в машине</span>
          </v-layout>
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md3
            >
              <span
                class="blue--text text--darken-4"
              >Категории проставлены:
              </span>
              <span>{{ totalReadyGoodsDetails }}/{{ routeItemsWithEx }}</span>
            </v-flex>
            <v-flex
              xs12
              md3
            >
              <span
                class="blue--text text--darken-4"
              >Готовность описания товаров:
              </span>
              <span>{{ shippingsWithLabelCategories }}/{{
                shippingsWithLabelInSystem
              }}</span>
            </v-flex>
            <v-flex
              xs12
              md2
            >
              <span class="blue--text text--darken-4">Кол-во мест: </span>
              <span>{{ cargoPlacesInCar }}</span>
            </v-flex>
            <v-flex
              xs12
              md2
            >
              <span class="blue--text text--darken-4">Вес брутто, кг: </span>
              <span>{{ weightInCar }}</span>
            </v-flex>
            <v-flex
              xs12
              md2
            >
              <span class="blue--text text--darken-4">Объем: </span>
              <span>{{ volumeInCar }}</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!-- ITEMS -->
      <v-flex xs12>
        <v-card
          class="mt-2 pa-2"
          :style="{ height: blockHeight - 228 + 'px' }"
        >
          <v-layout>
            <h2 class="ma-0 subheading font-weight-bold">
              Поставки
            </h2>
            <v-spacer />
            <DataColumnsSettings
              :columns="columns"
              resource="customsEntryRegistration"
              :settings-button-style="{
                flat: true,
                colorButton: '',
                colorIcon: 'grey'
              }"
            />
          </v-layout>
          <v-data-table
            v-if="route"
            :loading="itemsLoading"
            :items="items"
            :headers="visibleColumns"
            hide-actions
            class="mb-1 v-data-table--fixed-header"
            :style="{
              height: blockHeight - 290 + 'px',
              'overflow-y': 'auto',
              'overflow-x': 'auto'
            }"
          >
            <template
              slot="headers"
              slot-scope="props"
            >
              <tr class="text-xs-left px-3">
                <th
                  v-for="(header, index) in props.headers"
                  :key="index"
                  :style="{
                    minWidth: header.width ? `${header.width}px` : 'auto',
                    width: header.width ? `${header.width}px` : 'auto',
                    whiteSpace: header.width ? 'normal' : 'nowrap'
                  }"
                >
                  {{ header.title }}
                </th>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                :class="{
                  'red lighten-4':
                    props.item.isValidAfter === false ||
                    props.item.isValidBefore === false
                }"
              >
                <td
                  v-for="column in visibleColumns"
                  :key="column.name"
                >
                  <span v-if="column.type && column.type === 'editable'">
                    <v-edit-dialog
                      v-model="noteDialog"
                      lazy
                      large
                      cancel-text="Отмена"
                      save-text="Ок"
                      @cancel="cancelNoteDialog"
                      @open="openNoteDialog(props.item[column.name])"
                      @save="saveNote(props.item.RouteItemId, editingItem)"
                    >
                      <div class="link">
                        {{ props.item[column.name] || "_" }}
                      </div>
                      <template v-slot:input>
                        <v-text-field
                          v-model="editingItem"
                          class="ma-2"
                          outline
                          height="44"
                          hide-details
                        />
                      </template>
                    </v-edit-dialog>
                  </span>
                  <span
                    v-if="column.type && column.type === 'object'"
                  >{{
                    props.item[column.name]
                      ? props.item[column.name].Title
                      : ""
                  }}
                  </span>
                  <template v-if="column.type && column.type === 'text-array'">
                    <span
                      v-for="(item, index) in props.item[column.name]"
                      :key="index"
                    >
                      <span v-if="index === props.item[column.name].length - 1">
                        {{ item }}
                      </span>
                      <span v-else>
                        {{ `${item};` }}
                      </span>
                    </span>
                  </template>
                  <span v-else-if="column.type && column.type === 'boolean'">{{
                    props.item[column.name] ? "Да" : "Нет"
                  }}</span>
                  <span v-else-if="column.type && column.type === 'label'">
                    <v-menu
                      ref="ex-label-menu"
                      menu-props="offsetY"
                      :close-on-content-click="false"
                    >
                      <v-chip
                        slot="activator"
                        text-color="white"
                        label
                        small
                        :color="props.item.Ex[column.name2].color"
                      >{{ props.item.Ex[column.name].title }}</v-chip>

                      <v-list>
                        <v-list-tile
                          v-for="(variant, index) in getAvailableVariants(
                            props.item.Ex[column.name].id
                          )"
                          :key="index"
                          @click="
                            () => {
                              props.item.Ex[column.name] = variant;
                              changeExLabel(
                                props.item.Shipping,
                                variant.id,
                                'exWhoDoing',
                                true,
                                props.index
                              );
                            }
                          "
                        >
                          <v-list-tile-title>{{
                            variant.title
                          }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile style="height: 40px">
                          <v-switch
                            v-model="props.item.Ex[column.name2]"
                            hide-details
                            :false-value="ex.exDocumentInSystem.variants[0]"
                            :true-value="ex.exDocumentInSystem.variants[1]"
                            :label="props.item.Ex[column.name2].title"
                            @change="
                              changeExLabel(
                                props.item.Shipping,
                                props.item.Ex[column.name2].id,
                                'exDocumentInSystem',
                                true,
                                props.index
                              )
                            "
                          />
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </span>
                  <span v-else-if="column.type && column.type === 'bool'">
                    {{ props.item.Ex[column.name].id > 0 ? "Да" : "Нет" }}
                  </span>
                  <span v-else-if="column.type && column.type === 'doc-menu'">
                    <MenuAttachments
                      :data="formatDataForExport(props.item.Attachments)"
                      :data-for-export="
                        formatDataForExport(props.item.AttachmentsForExport)
                      "
                      :shipping-id="props.item.Shipping.Id"
                      :user="currentUser"
                      @update="getItems"
                    />
                  </span>
                  <span v-else-if="column.type && column.type === 'number'">
                    <router-link
                      :to="{ path: `/shippings/${props.item[column.name].Id}` }"
                      target="_blank"
                    >{{ props.item[column.name].Title }}</router-link>
                  </span>
                  <span v-else-if="column.type && column.type === 'link'">
                    <router-link
                      v-if="props.item[column.name]"
                      :to="{
                        path: `/goods-details/${props.item[column.name]}`
                      }"
                      target="_blank"
                    >{{ "Описание" }}</router-link>
                  </span>
                  <span v-else-if="!column.type">
                    {{ props.item[column.name] }}
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
          <app-action-confirm
            :value="сonfirmActionDialog"
            :text="
              `Подтвердить удаление значения в поле ${
                changedEntityInfo ? changedEntityInfo.title : ''
              }?`
            "
            @cancel="closeConfirmDialog"
            @confirm="confirmActionDialog"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import Lables from "./components/Lables.vue";
import Attachments from "../../components/attachments/Attachments.vue";
import DriverSelect from "../routes/components/DriverSelect.vue";
import DataColumnsSettings from "../../components/data-list/ColumnsSettings.vue";
import MenuStateChange from "../routes/components/MenuStateChange.vue";
import RouteReference from "../routes/components/RouteReference.vue";
import * as customsEntryRegistrationApi from "../../backend/customsEntryRegistrationApi.js";
import ConfirmMixin from "../../mixins/confirm-cancel-changes.js";
import CustomsManagerSelect from "../routes/components/CustomsManagerSelect.vue";
import StatesHistory from "./components/StatesHistory.vue";
import MenuAttachments from "../routes/components/MenuAttachments.vue";
import auth from "../../auth.js";

export default {
  components: {
    Lables,
    Attachments,
    DriverSelect,
    DataColumnsSettings,
    MenuStateChange,
    RouteReference,
    CustomsManagerSelect,
    StatesHistory,
    MenuAttachments,
  },
  mixins: [ConfirmMixin],
  props: ["id"],
  data() {
    return {
      headersDatesTable: [
        { text: "", sortable: false, align: "left" },
        { text: "План.", sortable: false, align: "left" },
        { text: "Факт.", sortable: false, align: "left" },
      ],
      itemsDatesTable: [
        {
          title: "Затаможки",
          plan: {
            field: "CustomsRegistrationDatePlan",
            readonly: true,
          },
          fact: { field: "CustomsRegistrationDateFact" },
        },
        {
          title: "Прохождения границы",
          plan: { field: "PassingBorderDatePlan" },
          fact: { field: "PassingBorderDateFact" },
        },
        {
          title: "Доставка к месту выгрузки",
          plan: { field: "ArriveToWarehouseDatePlan" },
          fact: { field: "ArriveToWarehouseDateFact" },
        },
      ],
      expandedGroups: [],
      placeholder: "0",
      showRoutePrefixEditor: false,
      routeItemsTableHeaders: [
        {
          title: "№",
          name: "rowNumber",
          sortable: false,
        },
        {
          title: "Коментарии",
          name: "Notes",
          sortable: false,
          type: "editable",
        },
        {
          title: "№ поставки",
          name: "Shipping",
          sortable: false,
          type: "number",
        },
        {
          title: "Продавец",
          name: "SenderFactory",
          sortable: false,
          type: "object",
        },
        { title: "Кол-во мест", name: "CargoPlaces", sortable: false },
        { title: "Вес брутто", name: "Weight", sortable: false },
        { title: "Объем", name: "Volume", sortable: false },
        {
          title: "Кол-во мест(из описания)",
          name: "GoodsDetailCargoPlaces",
          sortable: false,
        },
        {
          title: "Вес брутто(из описания)",
          name: "GoodsDetailWeight",
          sortable: false,
        },
        {
          title: "Объем(из описания)",
          name: "GoodsDetailVolume",
          sortable: false,
        },
        {
          title: "Метка EX",
          name: "ExWhoDoing",
          name2: "ExDocumentInSystem",
          sortable: false,
          type: "label",
          width: 200,
        },
        {
          title: "Наличие в системе",
          name: "ExDocumentInSystem",
          sortable: false,
          type: "bool",
          width: 200,
        },
        {
          title: "Документы",
          name: "Attachments",
          type: "doc-menu",
          sortable: false,
        },
        {
          title: "Контрагент",
          name: "Counterparty",
          sortable: false,
        },
        {
          title: "Клиент по документам",
          name: "ClientAlias",
          sortable: false,
          width: 100,
        },
        {
          title: "Клиент",
          name: "Client",
          sortable: false,
          type: "object",
        },
        {
          title: "Менеджер",
          name: "Manager",
          sortable: false,
          type: "object",
        },
        {
          title: "Менеджер по описанию",
          name: "ManagerByDescription",
          sortable: false,
          type: "object",
        },
        {
          title: "Производитель",
          name: "Manufacturer",
          sortable: false,
          type: "text-array",
        },
        {
          title: "Стоимость партии груза",
          name: "Cost",
          sortable: false,
          width: 100,
        },
        {
          title: "Описание",
          name: "GoodsDetailsId",
          sortable: false,
          type: "link",
        },
      ],
      activeTab: 0,
      isActiveExpeditionTab: false,
      reportList: [
        { resource: "expedition", title: "Отчет для Экспедитора" },
        { resource: "broker", title: "Отчет для Брокера" },
        { resource: "financier", title: "Отчет для Финансиста" },
        { resource: "warehouse", title: "Отчет для Склада" },
      ],
      сonfirmActionDialog: false,
      itemsLoading: false,
      loadingExcel: false,
      noteDialog: false,
      editingItem: "",
    };
  },
  computed: {
    route() {
      return this.$store.getters["customsEntryRegistration/getRoute"];
    },
    routeNumber() {
      return this.$store.getters["customsEntryRegistration/getRouteNumber"];
    },
    forwarder: {
      get() {
        return this.$store.getters["customsEntryRegistration/getForwarder"];
      },
      set(forwarder) {
        this.$store.commit("customsEntryRegistration/setForwarder", forwarder);
      },
    },
    routeEx: {
      get() {
        return this.$store.getters["customsEntryRegistration/getRouteEx"];
      },
      set(routeEx) {
        this.$store.commit("customsEntryRegistration/setRouteEx", routeEx);
      },
    },
    routeT1: {
      get() {
        return this.$store.getters["customsEntryRegistration/getRouteT1"];
      },
      set(routeT1) {
        this.$store.commit("customsEntryRegistration/setRouteT1", routeT1);
      },
    },
    routeTir: {
      get() {
        return this.$store.getters["customsEntryRegistration/getRouteTir"];
      },
      set(routeTir) {
        this.$store.commit("customsEntryRegistration/setRouteTir", routeTir);
      },
    },
    additionalExpenses: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getAdditionalExpenses"
        ];
      },
      set(additionalExpenses) {
        this.$store.commit(
          "customsEntryRegistration/setAdditionalExpenses",
          additionalExpenses,
        );
      },
    },
    loadingDates: {
      get() {
        return this.$store.getters["customsEntryRegistration/getLoadingDates"];
      },
      set(loadingDates) {
        this.$store.commit(
          "customsEntryRegistration/setLoadingDates",
          loadingDates,
        );
      },
    },
    loadingExpedition: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getLoadingExpedition"
        ];
      },
      set(loadingExpedition) {
        this.$store.commit(
          "customsEntryRegistration/setLoadingExpedition",
          loadingExpedition,
        );
      },
    },
    borderPassBlack: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassBlack"
        ];
      },
      set(borderPassBlack) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassBlack",
          borderPassBlack,
        );
      },
    },
    borderPassBlackCurrency: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassBlackCurrency"
        ];
      },
      set(borderPassBlackCurrency) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassBlackCurrency",
          borderPassBlackCurrency,
        );
      },
    },
    borderPassGreen: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassGreen"
        ];
      },
      set(borderPassGreen) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassGreen",
          borderPassGreen,
        );
      },
    },
    borderPassGreenCurrency: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassGreenCurrency"
        ];
      },
      set(borderPassGreenCurrency) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassGreenCurrency",
          borderPassGreenCurrency,
        );
      },
    },
    borderPassRegistration: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassRegistration"
        ];
      },
      set(borderPassRegistration) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassRegistration",
          borderPassRegistration,
        );
      },
    },
    borderPassRegistrationCurrency: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassRegistrationCurrency"
        ];
      },
      set(borderPassRegistrationCurrency) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassRegistrationCurrency",
          borderPassRegistrationCurrency,
        );
      },
    },
    borderPassStamp: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassStamp"
        ];
      },
      set(borderPassStamp) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassStamp",
          borderPassStamp,
        );
      },
    },
    borderPassStampCurrency: {
      get() {
        return this.$store.getters[
          "customsEntryRegistration/getBorderPassStampCurrency"
        ];
      },
      set(borderPassStampCurrency) {
        this.$store.commit(
          "customsEntryRegistration/setBorderPassStampCurrency",
          borderPassStampCurrency,
        );
      },
    },
    lables() {
      return this.$store.getters["customsEntryRegistration/getLables"];
    },
    attachments() {
      return this.$store.getters["customsEntryRegistration/getAttachments"];
    },
    blockHeight() {
      return window.innerHeight - 150;
    },
    cargoPlacesInCar() {
      return this.route ? this.route.CargoPlacesInCar : 0;
    },
    weightInCar() {
      return this.route ? this.route.WeightInCar : 0;
    },
    volumeInCar() {
      return this.route ? this.route.VolumeInCar : 0;
    },
    routeItemsInCar() {
      return this.route ? this.route.RouteItemsInCar : 0;
    },
    totalReadyGoodsDetails() {
      return this.route ? this.route.TotalReadyGoodsDetails : 0;
    },
    vehicle() {
      return this.route && this.route.Vehicle
        ? `${this.route.Vehicle.Number}-${this.route.Vehicle.TrailerNumber}`
        : "";
    },
    visibleColumns() {
      const columns = JSON.parse(JSON.stringify(this.routeItemsTableHeaders));
      columns.forEach(c => {
        const column = this.columnsSettings.find(sc => sc.name === c.name);
        if (column) {
          c.visible = column.visible;
          c.order = column.order;
        }
      });
      columns.sort((a, b) => {
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.routeItemsTableHeaders.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.routeItemsTableHeaders.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      return columns.filter(c => c.visible);
    },
    loading() {
      return this.$store.getters["customsEntryRegistration/getLoading"];
    },
    items() {
      return this.$store.getters["customsEntryRegistration/items"];
    },
    ex() {
      return this.$store.getters["customsEntryRegistration/ex"];
    },
    routeItemsWithEx() {
      return [...new Set(this.items.map(i => i.Shipping.Id))].length;
    },
    changedEntityInfo() {
      return this.$store.getters["customsEntryRegistration/changedEntityInfo"];
    },
    pageLoaded() {
      return !this.loading;
    },
    customsManager() {
      return this.$store.getters["customsEntryRegistration/customsManager"];
    },
    columnsSettings() {
      return this.$store.getters["customsEntryRegistration/columns"];
    },
    columns() {
      const columns = JSON.parse(JSON.stringify(this.routeItemsTableHeaders));
      columns.forEach(c => {
        c.visible = true;
        c.order = 0;
      });
      return columns;
    },
    currentUser() {
      return auth.getUser();
    },
    shippingsWithLabelCategories() {
      return this.route ? this.route.ShippingsWithLabelCategories : 0;
    },
    shippingsWithLabelInSystem() {
      return this.route ? this.route.ShippingsWithLabelInSystem : 0;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.$store.dispatch("customsEntryRegistration/getData", this.id);
    },
    async getItems() {
      await this.$store.dispatch("customsEntryRegistration/getItems", this.id);
    },
    expandGroup(index) {
      const expandedIndex = this.expandedGroups.indexOf(index);
      if (expandedIndex === -1) {
        this.expandedGroups.push(index);
      } else {
        this.expandedGroups.splice(expandedIndex, 1);
      }
    },
    async changeDates() {
      await this.$store.dispatch(
        "customsEntryRegistration/changeDates",
        this.id,
      );
      this.showInfo("Изменения сохранены");
    },
    async updateForwarder(element) {
      if (element) {
        await this.$store.dispatch("customsEntryRegistration/updateForwarder", {
          id: this.id,
          element,
        });
        this.showInfo("Экспедитор изменен");
      } else {
        this.$store.commit("customsEntryRegistration/setChangedEntityInfo", {
          title: "Экспедитор",
          name: "forwarder",
          value: element,
        });
        this.сonfirmActionDialog = true;
      }
    },
    async updateExpedition(nameMethod) {
      await this.$store.dispatch(
        `customsEntryRegistration/${nameMethod}`,
        this.id,
      );
      this.showInfo("Изменения сохранены");
    },
    async changeBorderPassCost(borderPassName, borderPassValue) {
      await this.$nextTick(() => {
        if (this[borderPassValue] === null) {
          return;
        } else if (this[borderPassValue] < 1) {
          this.showError(
            "Изменения не сохранены. Значение должно быть больше 0.",
          );
          return;
        }

        this.$store.dispatch("customsEntryRegistration/changeBorderPassCost", {
          id: this.id,
          type: borderPassName,
        });

        this.showInfo("Изменения сохранены");
      });
    },

    async downloadOutputForm(resource) {
      this.loadingExcel = true;
      const response = await customsEntryRegistrationApi.downloadOutputForm(
        this.id,
        resource,
      );
      this.downloadReportAsExcel(response.data, resource);
      this.columnsDialog = false;
      this.loadingExcel = false;
    },
    downloadReportAsExcel(fileData, resource) {
      const textInfo =
        resource === "expedition"
          ? "Отчет для экспедиции."
          : resource === "broker"
            ? "Отчет для брокера."
            : resource === "financier"
              ? "Отчет для финансиста."
              : resource === "warehouse"
                ? "Отчет для склада."
                : "";
      const blob = new Blob([fileData], { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${textInfo}${this.routeNumber}.xlsx`;
      link.click();
    },

    async saveRoutePrefix() {
      await this.$store.dispatch(
        "customsEntryRegistration/saveRoutePrefix",
        this.route.Id,
      );
      this.showRoutePrefixEditor = false;
      this.showInfo("Префикс изменен");
    },
    async changeDriver(element) {
      if (element) {
        const res = await customsEntryRegistrationApi.changeDriver(
          this.id,
          element?.id,
        );
        if (res.data) {
          this.$store.commit("customsEntryRegistration/setDriver", {
            id: res.data.Id,
            title: res.data.Title,
          });
        } else {
          this.$store.commit("route/setDriver", null);
        }
        this.showInfo("Водитель изменен");
      } else {
        this.$store.commit("customsEntryRegistration/setChangedEntityInfo", {
          title: "Водитель",
          name: "driver",
          value: element,
        });
        this.сonfirmActionDialog = true;
      }
    },
    async changeExLabel(shipping, variantId, labelName, close, row) {
      if (close && this.$refs["ex-label-menu"]) {
        this.$refs["ex-label-menu"][row].isActive = false;
      }
      this.itemsLoading = true;
      await customsEntryRegistrationApi.changeExLabel(
        shipping.Id,
        labelName,
        variantId,
      );
      this.itemsLoading = false;
      this.showInfo("Изменения сохранены");
    },
    getAvailableVariants(variantId) {
      return this.ex.exWhoDoing.variants.filter(v => v.id !== variantId);
    },
    async confirmActionDialog() {
      if (this.changedEntityInfo.name === "forwarder") {
        this.$store.dispatch("customsEntryRegistration/updateForwarder", {
          id: this.id,
          element: this.changedEntityInfo.value,
        });
        this.showInfo("Значение в поле Экспедитор удалено");
      }
      if (this.changedEntityInfo.name === "driver") {
        await customsEntryRegistrationApi.changeDriver(
          this.id,
          this.changedEntityInfo.value,
        );
        this.$store.commit("customsEntryRegistration/setDriver", null);
        this.showInfo("Значение в поле Водитель удалено");
      }
      this.сonfirmActionDialog = false;
    },
    closeConfirmDialog() {
      this.сonfirmActionDialog = false;
    },
    async changeCustomsManager(element) {
      await customsEntryRegistrationApi.changeCustomsManager(
        this.id,
        element?.id || null,
      );
      this.$store.commit(
        "customsEntryRegistration/setCustomsManager",
        element?.id ? element : null,
      );
      this.showInfo("Менеджер по затаможке изменен");
    },
    changeAttachments(value) {
      this.$store.commit("shipping/setAttachments", value);
    },
    openNoteDialog(note) {
      this.editingItem = note;
      this.noteDialog = true;
    },
    cancelNoteDialog() {
      this.noteDialog = false;
    },
    async saveNote(id, note) {
      await customsEntryRegistrationApi.changeNotes(id, note);
      this.noteDialog = false;
      this.editingItem = "";
      this.getItems();
    },
    formatDataForExport(data) {
      return data.map(a => {
        return {
          id: a.Id,
          title: a.Title,
        };
      });
    },
  },
};
</script>
<style>
.route-prefix.v-text-field--outline .v-text-field__slot input {
  margin-top: 0 !important;
}
.route-prefix.v-text-field--outline .v-input__slot {
  padding-left: 5px !important;
  padding-right: 0 !important;
}
.route-prefix.v-text-field--outline .v-input__slot .v-input__append-inner {
  margin-top: 2px !important;
}
</style>
